import React, { memo, forwardRef, ForwardedRef } from "react";
// libs
import Rating from "react-rating";
import NextImage from "next/image";
// types
import { IReactRatingProps } from "src/components/ui/Rating";
// theme
import { RatingWrapper } from "./rating.styles";

const ReactRatingComponent = (
  { initialRating, width, height, ...props }: IReactRatingProps,
  ref: ForwardedRef<Rating>,
) => {
  const FullSymbol = (
    <NextImage src="/icons/star-full-blue.svg" width={width || 25} height={height || 25} />
  );

  const EmptySymbol = (
    <NextImage src="/icons/star-empty-grey.svg" width={width || 25} height={height || 25} />
  );

  return (
    <RatingWrapper>
      <Rating
        ref={ref}
        step={1}
        fullSymbol={FullSymbol}
        emptySymbol={EmptySymbol}
        initialRating={initialRating && Math.round(initialRating)}
        className="rating"
        {...props}
      />
    </RatingWrapper>
  );
};

export default memo(forwardRef(ReactRatingComponent));
